export default {
  web: {
    footer: {
      product: "Product",
      company: "Company",
      download: "Download",
      pricing: "Pricing",
      bonuses: "Bonuses",
      copyright: "All rights reserved.",
    },
  },
};
